import { fetchGameIfPlayAllowed } from "../../utils/gamePlayGuard";
import {
	updateStats,
	updateTimer,
	getTimer,
	setLastTickNow,
} from "../../utils/helpers";
import { ROUTES } from "../../utils/constants";

/**
 * Antes en Scenario1Instructions: validar juego, actualizar stats/timer y permitir ir a /scenarios.
 * @returns {Promise<boolean>} true si debe navegarse a la pantalla de escenarios
 */
export async function scenario1ProceedToScenariosBoard({ game, group }) {
	const { ok } = await fetchGameIfPlayAllowed(game?._id);
	if (!ok) {
		return false;
	}

	const alreadyStarted = getTimer() !== null;

	if (alreadyStarted) {
		await updateStats({
			...group,
			lastVisited: ROUTES.TRANSITION_SCENARIOS,
		});
	} else {
		const time = group?.time ? parseInt(group.time, 10) : 0;
		updateTimer(time);
		setLastTickNow();

		await updateStats({
			...group,
			actualScenario: 1,
			time: 0,
			lastVisited: ROUTES.TRANSITION_SCENARIOS,
		});
	}

	return true;
}
